import _ from 'lodash';

export default function getPaginationHeaders(
	pagination,
	{ defaultPage = 1, defaultPageSize = 20 }
) {
	return {
		page: _.get(pagination, 'page', defaultPage),
		'page-size': _.get(pagination, 'pageSize', defaultPageSize),
	};
}
